<template>
  <div>
    <breadCrumb
      :icon="'fa-user-friends'"
      :category="$t(`sideNav.navSalonSetting`)"
      :subCategory="$t(`subMenu.salon_setting_staff`)"
      :subSubCategory="''"
    >
    </breadCrumb>
    <div v-if="!addStaffToggle" class="text-right mt-3 mr-5">
      <!-- <button
        class="btn buttons-csv buttons-html5 btn-outline-primary"
        type="button"
        title="Add New Staff"
        @click="addStaffToggle = !addStaffToggle"
      >
        <span class="fal fa-plus mr-2"></span>
        <span>{{
          $t("button_link.add") + $t(`subMenu.salon_setting_staff`)
        }}</span>
      </button> -->
      <button
        class="btn buttons-csv buttons-html5 btn-outline-primary"
        type="button"
        title="Add New Staff"
        v-b-toggle.addStaffDrawer
      >
        <span class="fal fa-plus mr-2"></span>
        <span>{{
          $t("button_link.add") + $t(`subMenu.salon_setting_staff`)
        }}</span>
      </button>
    </div>
    <div v-if="addStaffToggle" class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr">
          <h2>
            {{ $t("button_link.add") + $t(`subMenu.salon_setting_staff`) }}
          </h2>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <!-- <staffForm
              ref="staffForm"
              :isEdit="false"
              @submitStaffDetails="addStaff"
              @returnStaffList="closeModal"
            ></staffForm> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!addStaffToggle" class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr d-block pt-4 p-3">
          <div class="ml-auto mb-3 text-right">
            <exportCSV
              class="link btn buttons-csv buttons-html5 btn-primary mr-2"
              :data="exportData"
              :fields="exportFields"
              :header="exportHeaders"
              type="csv"
              :escapeCsv="false"
              :name="exportFileName"
            >
              <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start"
            >
              <div class="dataTables_filter">
                <label class="d-flex mb-0">
                  <input
                    type="search"
                    class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                    :placeholder="$t('label.search')"
                    v-model="searchStaff"
                    @keypress.enter="filterSearchStaff"
                  />
                  <button
                    class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                    @click="filterSearchStaff"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
              <div class="form-group d-flex">
                <div class="input-group-prepend w-100">
                  <label
                    class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0"
                  >
                    <i class="fas fa-store"></i>
                  </label>
                  <multiselect
                    v-model="selectedOutlet"
                    label="text"
                    track-by="id"
                    :options="outlet"
                    :searchable="false"
                    :show-labels="false"
                    openDirection="below"
                    @select="filterByOutlet"
                  >
                    <template slot="option" slot-scope="{ option }">{{
                      option.text
                    }}</template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <a class="link text-primary" @click="clearFilter">{{
            $t("button_link.clear_filter")
          }}</a>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <div
              v-if="isSpinnerShow"
              class="d-flex justify-content-center mt-3 mb-3"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div
              class="panel-tag mt-3"
              v-if="!isSpinnerShow && totalEntries == 0"
            >
              {{ $t("table.no_records") }}
            </div>
            <div
              v-if="!isSpinnerShow && totalEntries != 0"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row justify-content-end mt-2">
                <div class="col-auto pt-2">
                  <span>{{
                    $t("table.pagination", {
                      startPage: startPage,
                      endPage: endPage,
                      totalEntries: totalEntries,
                    })
                  }}</span>
                </div>
                <div class="col-auto">
                  <b-pagination
                    class="ml-3"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalEntries"
                    @input="handlePagination"
                    aria-controls="tblProductItems"
                  ></b-pagination>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 overflow-auto">
                  <!-- <b-table striped :items="staffItems" :fields="fields">
                    <template #cell(index)="data">
                      {{ data.index }}
                    </template>
                    <template #cell(avatar)="data">
                      <div class="d-flex justify-content-center">
                        <b-avatar
                          :src="
                            data.item.image !== ''
                              ? data.item.image
                              : data.item.icon
                          "
                          size="6rem"
                        ></b-avatar>
                      </div>
                    </template>
                    <template #cell(staff)="data">
                      <a
                        @click="
                          editStaffDetails(
                            data.item.staffID,
                            data.item.name,
                            data.item.employee.nationalID,
                            data.item.employee.number,
                            data.item.mobile
                          )
                        "
                        v-b-modal.editStaffDetailsModal
                        class="d-flex flex-column w-100 link"
                      >
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center">
                            <b-icon icon="person" class="mr-2"></b-icon>
                            <span class="text-bold">{{ data.item.name }}</span>
                          </div>
                          <a>
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a>
                        </div>
                        <div class="d-flex align-items-center">
                          <b-icon icon="phone" class="mr-2"></b-icon>
                          {{ data.item.mobile }}
                        </div>
                        <div class="d-flex align-items-center">
                          <b-icon icon="card-text" class="mr-2"></b-icon>
                          {{
                            data.item.employee.nationalID != ""
                              ? data.item.employee.nationalID
                              : "N/A"
                          }}
                        </div>
                      </a>
                    </template>
                    <template #cell(target)="data">
                      <a
                        @click="
                          editStaffTargets(
                            data.item.staffID,
                            data.item.target.service,
                            data.item.target.product,
                            data.item.target.package
                          )
                        "
                        v-b-modal.editStaffTargetsModal
                        class="d-flex flex-column w-100 link"
                      >
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center w-100">
                            <span class="mr-2 col-4">Service</span>
                            <span>{{ data.item.target.service }}</span>
                          </div>
                          <a>
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a>
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="mr-2 col-4">Product</span>
                          <span>{{ data.item.target.product }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="mr-2 col-4">Package</span>
                          <span>{{ data.item.target.package }}</span>
                        </div>
                      </a>
                    </template>
                    <template #cell(permission)="data">
                      <div class="d-flex flex-column">
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="data.item.showOnline"
                            @input="
                              permissionChange(
                                $event,
                                data.item.staffID,
                                'online'
                              )
                            "
                            switch
                            >Show for Online</b-form-checkbox
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="data.item.showWork"
                            @input="
                              permissionChange(
                                $event,
                                data.item.staffID,
                                'work'
                              )
                            "
                            switch
                            >Show for Worksheet</b-form-checkbox
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="data.item.showAppt"
                            @input="
                              permissionChange(
                                $event,
                                data.item.staffID,
                                'appt'
                              )
                            "
                            switch
                            >Show for Appointment</b-form-checkbox
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            v-model="data.item.enable"
                            @input="
                              permissionChange(
                                $event,
                                data.item.staffID,
                                'enable'
                              )
                            "
                            switch
                            >Show for Target user in App</b-form-checkbox
                          >
                        </div>
                      </div>
                    </template>
                  </b-table> -->
                  <b-table-simple>
                    <b-thead>
                      <b-tr>
                        <b-td> # </b-td>
                        <b-td> Photo </b-td>
                        <b-td> Staff Information </b-td>
                        <b-td> Performance Target </b-td>
                        <b-td> Permission </b-td>
                        <!-- <b-td></b-td> -->
                        <b-td></b-td>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(item, index) in staffItems" :key="index">
                        <b-td>
                          {{ index + 1 }}
                        </b-td>
                        <b-td class="">
                          <div class="d-flex justify-content-center">
                            <b-avatar
                              :src="item.image !== '' ? item.image : item.icon"
                              size="6rem"
                            ></b-avatar>
                          </div>
                        </b-td>
                        <b-td class="hoverColumn">
                          <a
                            @click="
                              editStaffDetails(
                                item.staffID,
                                item.name,
                                item.employee.nationalID,
                                item.employee.number,
                                item.mobile
                              )
                            "
                            v-b-modal.editStaffDetailsModal
                            class="d-flex flex-column w-100 link"
                          >
                            <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center">
                                <b-icon icon="person" class="mr-2"></b-icon>
                                <span class="text-bold">{{ item.name }}</span>
                              </div>
                              <a>
                                <b-icon
                                  variant="primary"
                                  icon="pencil"
                                ></b-icon>
                              </a>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-icon icon="phone" class="mr-2"></b-icon>
                              {{ item.mobile }}
                            </div>
                            <div class="d-flex align-items-center">
                              <b-icon icon="card-text" class="mr-2"></b-icon>
                              {{
                                item.employee.nationalID != ""
                                  ? item.employee.nationalID
                                  : "N/A"
                              }}
                            </div>
                          </a>
                        </b-td>
                        <b-td class="hoverColumn">
                          <a
                            @click="
                              editStaffTargets(
                                item.staffID,
                                item.target.service,
                                item.target.product,
                                item.target.package
                              )
                            "
                            v-b-modal.editStaffTargetsModal
                            class="d-flex flex-column w-100 link"
                          >
                            <div class="d-flex justify-content-between">
                              <div class="d-flex align-items-center w-100">
                                <span class="mr-2">Service</span>
                                <span>{{ item.target.service }}</span>
                              </div>
                              <a>
                                <b-icon
                                  variant="primary"
                                  icon="pencil"
                                ></b-icon>
                              </a>
                            </div>
                            <div class="d-flex align-items-center">
                              <span class="mr-2">Product</span>
                              <span>{{ item.target.product }}</span>
                            </div>
                            <div class="d-flex align-items-center">
                              <span class="mr-2">Package</span>
                              <span>{{ item.target.package }}</span>
                            </div>
                          </a>
                        </b-td>
                        <b-td>
                          <div class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showOnline"
                                @input="
                                  permissionChange(
                                    $event,
                                    item.staffID,
                                    'online'
                                  )
                                "
                                switch
                                >Show for Online</b-form-checkbox
                              >
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showWork"
                                @input="
                                  permissionChange($event, item.staffID, 'work')
                                "
                                switch
                                >Show for Worksheet</b-form-checkbox
                              >
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.showAppt"
                                @input="
                                  permissionChange($event, item.staffID, 'appt')
                                "
                                switch
                                >Show for Appointment</b-form-checkbox
                              >
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                v-model="item.enable"
                                @input="
                                  permissionChange(
                                    $event,
                                    item.staffID,
                                    'enable'
                                  )
                                "
                                switch
                                >Show for Target user in App</b-form-checkbox
                              >
                            </div>
                          </div>
                        </b-td>
                        <!-- <b-td class="align-items-center">
                          <div class="d-flex flex-column">
                            <b-button v-if="item.carwasher.carwasherID === ''" pill class="mb-1" @click="createWD(item.staffID,item.name,'carwasher')" variant="outline-primary">
                            Add Car Washer
                          </b-button>
                          <b-button v-else pill class="mb-1" @click="deleteWD(item.staffID,item.name,'carwasher')" variant="outline-primary">
                            Delete Car Washer
                          </b-button>
                          <b-button v-if="item.doctor.doctorID === ''" pill variant="outline-success" @click="createWD(item.staffID,item.name,'doctor')" >
                            Add Doctor
                          </b-button>
                          <b-button v-else pill variant="outline-success" @click="deleteWD(item.staffID,item.name,'doctor')" >
                            Delete Doctor
                          </b-button>
                          </div>
                        </b-td> -->
                        <b-td class="align-items-center">
                          <a
                            class="link"
                            @click="deleteStaff(item.staffID, item.name)"
                          >
                            <b-icon
                              variant="danger"
                              style="font-size: 15px"
                              icon="trash"
                            ></b-icon>
                          </a>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="editStaffDetailsModal" title="Edit Staff Details">
      <div class="d-flex flex-column mb-2">
        <label>Name</label>
        <b-form-input v-model="staffDetails.name" type="text"></b-form-input>
      </div>
      <div class="d-flex flex-column mb-2">
        <label>Mobile Number</label>
        <b-form-input
          v-model="staffDetails.mobile"
          disabled
          type="text"
        ></b-form-input>
      </div>
      <div class="d-flex flex-column mb-2">
        <label>National ID</label>
        <b-form-input
          v-model="staffDetails.nationalID"
          type="text"
        ></b-form-input>
      </div>
      <div class="d-flex flex-column">
        <label>Employee Number</label>
        <b-form-input v-model="staffDetails.empNum" type="text"></b-form-input>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffDetailsModal')"
              >Cancel</b-button
            >
            <b-button variant="primary" class="ml-2" @click="editDetails()"
              >Confirm</b-button
            >
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal id="editStaffTargetsModal" title="Edit Staff Targets">
      <div class="d-flex">
        <div class="d-flex flex-column mb-2">
          <label>Service</label>
          <b-form-input
            v-model="staffDetails.service"
            type="text"
          ></b-form-input>
        </div>
        <div class="d-flex flex-column mx-2 mb-2">
          <label>Product</label>
          <b-form-input
            v-model="staffDetails.product"
            type="text"
          ></b-form-input>
        </div>
        <div class="d-flex flex-column">
          <label>Package</label>
          <b-form-input
            v-model="staffDetails.package"
            type="text"
          ></b-form-input>
        </div>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="closeModal('editStaffTargetsModal')"
              >Cancel</b-button
            >
            <b-button variant="primary" class="ml-2" @click="editTargets()"
              >Confirm</b-button
            >
          </div>
        </div>
      </template>
    </b-modal>
    <StaffForm :outlet="outlet" :selected="selectedOutlet" @addDone="addDone" />
  </div>
</template>

<script>
import BreadCrumb from "./../../Bread_Crumb";
import StaffForm from "./Staff_Form_Drawer";

import moment from "moment";
import {
  setReturnData,
  handleSessionExpired,
} from "./../../../../assets/js/dashboard/dashboard";
import Swal from "sweetalert2";

export default {
  name: "staff",
  components: {
    StaffForm,
    BreadCrumb,
  },
  data() {
    return {
      isSpinnerShow: false,
      addStaffToggle: false,
      editToggleModal: false,
      deleteToggleModal: false,
      searchStaff: "",
      outlet: [],
      selectedOutlet: {},
      staffItems: [],
      staffData: [],
      staffDetails: {
        id: 0,
        name: "",
        nationalID: "",
        empNum: "",
        service: 0,
        product: 0,
        package: 0,
        mobile: "",
      },
      formItem: {},
      sID: 0,
      name: "",
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      exportHeaders: [],
      exportData: [],
      exportFileName: "",
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed text-center",
          tdClass: "text-center",
        },
        {
          key: "avatar",
          label: "Avatar",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "staff",
          label: "Staff Information",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle hoverColumn",
        },
        {
          key: "target",
          label: "Performance Target",
          thClass: "thead-themed text-center",
          tdClass: "text-center align-middle hoverColumn",
        },
        {
          key: "permission",
          label: "Permissions",
          thClass: "thead-themed text-center",
          tdClass: "text-center align-middle",
        },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.contact").toUpperCase()] = "mobile";
      ret[this.$i18n.t("outlet_setting.staff.online").toUpperCase()] = "online";
      ret[this.$i18n.t("outlet_setting.staff.work").toUpperCase()] =
        "worksheet";
      ret[this.$i18n.t("outlet_setting.staff.appt").toUpperCase()] =
        "appointment";
      return ret;
    },
  },
  methods: {
    addDone(res) {
      console.log(res);
      if (res.status === 200) {
        this.toastrExe("Add Staff", "Successfully added staff", "success");
        this.getStaffItems();
      } else {
        this.toastrExe(
          "Add Staff",
          "Failed to add staff, mobile number exists.",
          "danger"
        );
      }
    },
    permissionChange(event, staffID, permission) {
      let body = null;
      let $vm = this;
      let result = [];
      let check = null;
      let url = `${this.$api.BEBUSINESS_STAFF}/${staffID}/${permission}`;
      if (permission == "appt") body = { showAppt: event ? 1 : 0 };
      else if (permission == "work") body = { showWork: event ? 1 : 0 };
      else if (permission == "online") body = { showOnline: event ? 1 : 0 };
      else if (permission == "enable") body = { enable: event ? 1 : 0 };
      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: body,
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    editStaffDetails(id, name, nationalID, empNum, mobile) {
      this.staffDetails.id = id;
      this.staffDetails.name = name;
      this.staffDetails.nationalID = nationalID;
      this.staffDetails.empNum = empNum;
      this.staffDetails.mobile = mobile;
    },
    editStaffTargets(id, service, product, pckg) {
      this.staffDetails.id = id;
      this.staffDetails.service = service;
      this.staffDetails.product = product;
      this.staffDetails.package = pckg;
    },
    async editDetails() {
      let $vm = this;
      let url =
        this.$api.BEBUSINESS_STAFF +
        "/" +
        this.staffDetails.id +
        this.$api.STAFF_DETAIL_UPDATE;
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: {
            name: $vm.staffDetails.name,
            number: $vm.staffDetails.empNum,
            nationalID: $vm.staffDetails.nationalID,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      console.log(result);
      if (result.status === 200) {
        this.$bvModal.hide("editStaffDetailsModal");
        this.toastrExe(
          "Staff Detail",
          `Staff ID ${this.staffDetails.id} details have been updated`,
          "success"
        );
        this.getStaffItems();
      } else {
        this.toastrExe("Staff Detail", `Update failed.`, "danger");
      }
    },
     async createWD(id, name,type) {
      let flag = false;
      await Swal.fire({
        title: `Confirm create ${type} for ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + '/'+type+'/create';
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.toastrExe(
          "Create",
          `Staff ID: ${id} transformed into ${type}.`,
          "success"
        );
        this.getStaffItems();
      } else this.toastrExe("Create", "Error", "danger");
    },
     async deleteWD(id, name,type) {
      let flag = false;
      await Swal.fire({
        title: `Confirm create ${type} for ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + '/'+type+'/delete';
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.toastrExe(
          "Delete",
          `Staff ID: ${id} transformed into ${type}.`,
          "success"
        );
        this.getStaffItems();
      } else this.toastrExe("Delete", "Error", "danger");
    },
    async deleteStaff(id, name) {
      let flag = false;
      await Swal.fire({
        title: `Confirm delete Staff ${name}?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      let url = this.$api.BEBUSINESS_STAFF + "/" + id + this.$api.DELETE;
      let result = [];

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.toastrExe(
          "Delete Staff",
          `Staff ID: ${id} has been deleted`,
          "success"
        );
        this.getStaffItems();
      } else this.toastrExe("Delete Staff", "Error", "danger");
    },
    editTargets() {
      let $vm = this;
      let url =
        this.$api.BEBUSINESS_STAFF +
        "/" +
        this.staffDetails.id +
        this.$api.STAFF_TARGET_UPDATE;
      let result = [];

      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_STAFF,
          headers: { token: $vm.$session.get("token") },
          data: {
            service: $vm.staffDetails.service,
            product: $vm.staffDetails.product,
            package: $vm.staffDetails.package,
          },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.$bvModal.hide("editStaffTargetsModal");
      this.toastrExe(
        "Staff Target",
        `Staff ID ${this.staffDetails.id} targets have been updated, refresh to update list.`,
        "success"
      );
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    clearFilter() {
      this.searchStaff = "";
      this.selectedOutlet = this.outlet[0];
      this.getStaffItems("");
    },
    filterByOutlet(event) {
      this.selectedOutlet = event;
      this.getStaffItems();
    },
    filterSearchStaff(event) {
      this.staffItems.slice(0, this.staffItems.length, ...this.staffData);

      this.staffItems = this.staffData.filter((item) => {
        let staff = item.name.toUpperCase();
        let search = this.searchStaff.toUpperCase();
        if (item.deleteDate == 0) {
          if (
            staff.includes(search) ||
            item.mobile.includes(this.searchStaff)
          ) {
            return item;
          }
        }
      });
      var retData = setReturnData(
        this.staffItems,
        this.staffItems.length,
        this.page
      );
      console.log(retData);
      this.staffItems = retData.result;
      this.totalEntries = retData.count;
      this.totalPage = retData.totalPage;
      this.startPage = retData.startPage;
      this.endPage = retData.endPage;
    },
    async getExportData(strFilter) {
      let $vm = this;
      let QUERY_STRING =
        "/" + this.selectedOutlet.id + this.$api.STAFF + strFilter;
      const url = this.$api.OUTLET + QUERY_STRING;

      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.staff;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.setExportData(result);
    },
    setExportData(data) {
      this.exportData = [];
      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t("sideNav.navSalonSetting") +
        " - " +
        this.$i18n.t(`subMenu.salon_setting_staff`);
      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];
      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          name: data[i].title,
          contact: data[i].mobile,
          online:
            data[i].show.online == 1
              ? this.$i18n.t("outlet_setting.staff.online")
              : "-",
          worksheet:
            data[i].show.work == 1
              ? this.$i18n.t("outlet_setting.staff.work")
              : "-",
          appointment:
            data[i].show.appt == 1
              ? this.$i18n.t("outlet_setting.staff.appt")
              : "-",
        });
      }
    },
    async getStaffItems() {
      let $vm = this;
      let QUERY_STRING = this.$api.BEBUSINESS_STAFF;
      const url = $vm.$api.API_ENDPOINT_STAFF + QUERY_STRING;

      $vm.isSpinnerShow = true;
      $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          let staff = response.data.staffs;
          staff.forEach((element) => {
            element.showAppt = element.showAppt === 1 ? true : false;
            element.showOnline = element.showOnline === 1 ? true : false;
            element.showWork = element.showWork === 1 ? true : false;
            element.enable = element.enable === 1 ? true : false;
          });
          staff = staff.filter(
            (s) => s.deleteDate === 0 && s.outletID === $vm.selectedOutlet.id
          );
          var retData = setReturnData(staff, staff.length, $vm.page);
          $vm.staffItems = retData.result;
          $vm.staffData = retData.result;
          $vm.totalEntries = retData.count;
          $vm.totalPage = retData.totalPage;

          $vm.startPage = retData.startPage;
          $vm.endPage = retData.endPage;
          $vm.isSpinnerShow = false;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          } else {
            $vm.$parent.setModal(
              this,
              true,
              true,
              $vm.$i18n.t("message.error.system_error")
            );
          }
        });
      //await this.getExportData(strFilter)
    },
    handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        this.getStaffItems("");
      }
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);
    $vm.selectedOutlet = $vm.outlet[0];
    $vm.getStaffItems("");
  },
};
</script>

<style scoped>
.show {
  display: block;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
}
.hoverColumm {
  min-height: 1px;
}
.hoverColumn:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
</style>